var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card shadow-sm mt-3" }, [
    _c("div", { staticClass: "card-body" }, [
      _c(
        "div",
        [
          _c("Multiselect", {
            attrs: {
              options: _vm.campaigns,
              multiple: false,
              taggable: false,
              "track-by": "campaignId",
              label: "name",
              placeholder: "Select a campaign",
              loading: _vm.isLoadingCampaigns,
            },
            model: {
              value: _vm.selectedCampaign,
              callback: function ($$v) {
                _vm.selectedCampaign = $$v
              },
              expression: "selectedCampaign",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "align-items-center mt-3" }, [
        _c("div", { staticClass: "row d-flex align-items-center" }, [
          _c(
            "div",
            {
              staticClass:
                "col-md-6 d-flex justify-content-center custom-control custom-radio",
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectedReportType,
                    expression: "selectedReportType",
                  },
                ],
                staticClass: "custom-control-input",
                attrs: {
                  id: "campaign-report",
                  type: "radio",
                  value: "campaign",
                },
                domProps: {
                  checked: _vm._q(_vm.selectedReportType, "campaign"),
                },
                on: {
                  change: function ($event) {
                    _vm.selectedReportType = "campaign"
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "custom-control-label",
                  attrs: { for: "campaign-report" },
                },
                [_vm._v("\n            Campaign Report\n          ")]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "col-md-6 d-flex justify-content-center custom-control custom-radio",
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectedReportType,
                    expression: "selectedReportType",
                  },
                ],
                staticClass: "custom-control-input",
                attrs: {
                  id: "creative-report",
                  type: "radio",
                  value: "creative",
                },
                domProps: {
                  checked: _vm._q(_vm.selectedReportType, "creative"),
                },
                on: {
                  change: function ($event) {
                    _vm.selectedReportType = "creative"
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "custom-control-label",
                  attrs: { for: "creative-report" },
                },
                [_vm._v("\n            Creative Report\n          ")]
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row d-flex align-items-center mt-3" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c(
              "label",
              {
                staticClass: "mb-0 mr-2 font-weight-bold",
                attrs: { for: "start-date" },
              },
              [_vm._v("\n            Start Date\n          ")]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.startDate,
                  expression: "startDate",
                },
              ],
              staticClass: "form-control form-control-sm mr-3",
              staticStyle: { "min-width": "140px" },
              attrs: { id: "start-date", type: "date", max: _vm.yesterdayDate },
              domProps: { value: _vm.startDate },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.startDate = $event.target.value
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c(
              "label",
              {
                staticClass: "mb-0 mr-2 font-weight-bold",
                attrs: { for: "end-date" },
              },
              [_vm._v("\n            End Date\n          ")]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.endDate,
                  expression: "endDate",
                },
              ],
              staticClass: "form-control form-control-sm",
              staticStyle: { "min-width": "140px" },
              attrs: { id: "end-date", type: "date", max: _vm.yesterdayDate },
              domProps: { value: _vm.endDate },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.endDate = $event.target.value
                },
              },
            }),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.error
        ? _c(
            "div",
            {
              staticClass:
                "alert alert-danger d-flex justify-content-center w-100 mt-3",
              attrs: { role: "alert" },
            },
            [
              _c("i", { staticClass: "fas fa-exclamation-triangle mr-2 mt-1" }),
              _vm._v(_vm._s(_vm.error) + "\n    "),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "mt-3 d-flex justify-content-end" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-primary btn-sm",
            attrs: { disabled: _vm.isLoading || _vm.isLoadingCampaigns },
            on: { click: _vm.getReport },
          },
          [
            !_vm.isLoading
              ? _c("i", { staticClass: "fas fa-file-download mr-2" })
              : _vm._e(),
            _vm._v(" "),
            _vm.isLoading
              ? _c("i", { staticClass: "fas fa-spinner fa-spin mr-2" })
              : _vm._e(),
            _vm._v("\n        Get report\n      "),
          ]
        ),
      ]),
      _vm._v(" "),
      _vm.csvData
        ? _c("div", { staticClass: "table-responsive mt-4" }, [
            _c(
              "table",
              {
                staticClass:
                  "table table-bordered table-hover table-sm bg-white",
              },
              [
                _c("thead", { staticClass: "thead-light" }, [
                  _c(
                    "tr",
                    _vm._l(_vm.csvData[0], function (header, idx) {
                      return _c("th", { key: "header-" + idx }, [
                        _vm._v(
                          "\n              " + _vm._s(header) + "\n            "
                        ),
                      ])
                    }),
                    0
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.csvData.slice(1), function (row, rowIdx) {
                    return _c(
                      "tr",
                      { key: "row-" + rowIdx },
                      _vm._l(row, function (cell, cellIdx) {
                        return _c(
                          "td",
                          { key: "cell-" + rowIdx + "-" + cellIdx },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(cell) +
                                "\n            "
                            ),
                          ]
                        )
                      }),
                      0
                    )
                  }),
                  0
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "mt-3 d-flex justify-content-end" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-outline-primary btn-sm mt-2",
                  on: { click: _vm.downloadCSV },
                },
                [
                  _c("i", { staticClass: "fas fa-download mr-1" }),
                  _vm._v("\n          Download CSV\n        "),
                ]
              ),
            ]),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }